export { getSofePath };

function getSofePath(serviceName) {
  // Inverted so webpack prunes the require, and the sofe dependency with it, out of the
  // ESM build. A static top-level import would survive into the bundle and fail to
  // resolve, because sofe has no ESM equivalent.
  if (process.env.ESM_BUILD !== "true") {
    const { getServiceUrl } = require("sofe");
    const serviceUrl = getServiceUrl(serviceName);
    const localDomain =
      localStorage.getItem("sofe:local-domain") || "https://localhost";

    if (parseInt(serviceUrl, 10) + "" === serviceUrl) {
      // The URL of the service is an override to localhost on a particular port
      return `${localDomain}:${serviceUrl}/`;
    }

    return serviceUrl.substring(0, serviceUrl.lastIndexOf("/") + 1);
  }

  // Every caller uses this to set __webpack_public_path__, which the ESM build does not
  // need, since canopy-webpack-config/esm sets publicPath to "auto". Reaching here means
  // a consumer still has to gate its own public-path assignment on ESM_BUILD.
  throw new Error(
    `getSofePath("${serviceName}") is not available in the ESM build. Services resolve ` +
      `through the import map, and publicPath: "auto" replaces __webpack_public_path__.`,
  );
}
